module.exports = __webpack_public_path__ + "img/Group 27108@2x.08b32402.png";